export const START_DATE = 'startDate';
export const END_DATE = 'endDate';
export const DATE_FORMAT = 'D MMM YYYY';
